import {useIndexedDB} from "react-indexed-db-hook";
import {useEffect, useState} from "react";

export default function useEmailsState() {
	const dbValues = useIndexedDB("emails");
	const { getAll, add, deleteRecord, getByIndex: _getByIndex, clear: clearAll, getByID} = dbValues;

	const [emails, setEmails] = useState([]);
	useEffect(() => {
		getAll()
			.then((valuesFromDB) => {
				setEmails(valuesFromDB);
			})
			.catch(() => setEmails([]));
	}, [dbValues]);

	const getByIndex = (indexName: string, key: any) => {
		if (indexName === 'id') {
			key = parseInt(key);
		}
		return emails.find(emails => emails[indexName] === key);
	}

	const deleteByIndex = (indexName: string, key: any) => {
		if (indexName === 'id') {
			return deleteRecord(parseInt(key))
		} else {
			return _getByIndex(indexName, key).then((card) => deleteRecord(card.id));
		}
	}

	return {emails, add, deleteRecord, getByIndex, getByIndexAsync: _getByIndex, deleteByIndex, clearAll};
}